import { useGetCurrentTenantQuery } from '@/api/tenants.api'
import { useAuthStore } from '@/store/auth.store'

/**
 * Current tenant info. Falls back to the tenant id from the JWT until the
 * /tenants/current call resolves the human-readable name.
 */
export function useTenant() {
  const tenantId = useAuthStore((s) => s.user?.tenantId)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const { data, isLoading, error } = useGetCurrentTenantQuery(undefined, {
    skip: !isAuthenticated,
  })

  return {
    tenantId,
    tenantName: data?.name ?? '',
    tenant: data,
    isLoading,
    error,
  }
}
